import sharedVars from '../../shared-vars.json';

const { breakpoints } = sharedVars;

export default {
    props: {
        totalSlides: Number,
    },
    swiper: null,
    smallMql: null,
    tinyMql: null,
    data: () => ({
        small: false,
        tiny: false,
        flash: false,
    }),
    computed: {
        slidesPerView() {
            if (this.tiny) {
                return 1;
            }

            if (this.small) {
                return 3;
            }

            return 5;
        },
        showNavigation() {
            return this.totalSlides >= this.slidesPerView;
        },
        options() {
            return {
                slidesPerView: this.slidesPerView,
                loop: this.showNavigation,
                preventInteractionOnTransition: true,
                allowSlidePrev: this.showNavigation,
                allowSlideNext: this.showNavigation,
                autoplay: !this.showNavigation ? false : {
                    delay: 2000,
                },
            };
        },
    },
    mounted() {
        this.$options.smallMql = window.matchMedia(`(max-width: ${breakpoints.small}px)`);
        this.small = this.$options.smallMql.matches;
        this.$options.smallMql.addListener(this.onSmallChange);

        this.$options.tinyMql = window.matchMedia(`(max-width: ${breakpoints.tiny}px)`);
        this.tiny = this.$options.tinyMql.matches;
        this.$options.tinyMql.addListener(this.onTinyChange);
    },
    beforeDestroy() {
        this.$options.smallMql.removeListener(this.onSmallChange);
        this.$options.tinyMql.removeListener(this.onTinyChange);
    },
    render() {
        if (this.flash) return null;

        return this.$scopedSlots.default({
            options: this.options,
            showNavigation: this.showNavigation,
            registerSwiper: this.registerSwiper,
            previous: this.previous,
            next: this.next,
        });
    },
    methods: {
        registerSwiper({ component }) {
            this.$options.swiper = component.swiper;
        },
        previous() {
            this.$options.swiper.slidePrev();
        },
        next() {
            this.$options.swiper.slideNext();
        },
        onSmallChange(evt) {
            this.small = evt.matches;
            this.flash = true;
        },
        onTinyChange(evt) {
            this.tiny = evt.matches;
            this.flash = true;
        },
    },

    watch: {
        flash(val) {
            if (val) {
                this.$nextTick(() => {
                    this.flash = false;
                });
            }
        },
    },
};
